import React from "react";
import { Box, Divider } from "@mui/material";

import CollectionShipmentList from "./CollectionShipmentList";

const CollectionShipmentTab = () => {
  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}></Box>
      <Divider />
      <CollectionShipmentList />
    </>
  );
};

export default CollectionShipmentTab;